import * as React from "react";
import useInterval from "@/react/useInterval";
import { useErrorNotification } from "@/react/notifications";

import { useLazyGetFilteredJobsQuery } from "./api";
import { Recency, RefreshRate } from "./types";

const useJobs = () => {
  const [recency, setRecency] = React.useState(Recency.ONE_MONTH);
  const [refreshRate, setRefreshRate] = React.useState(
    RefreshRate.FIVE_MINUTES
  );

  const [retrieveJobs, { data, isFetching, error }] =
    useLazyGetFilteredJobsQuery();

  const refetch = React.useCallback(() => {
    if (isFetching) {
      return;
    }

    retrieveJobs({
      recency,
    });
  }, [retrieveJobs, isFetching, recency]);

  React.useEffect(() => {
    refetch();
  }, [recency, refreshRate]);

  useInterval(refetch, refreshRate);

  useErrorNotification(error);

  return {
    recency,
    setRecency,
    refreshRate,
    setRefreshRate,
    data,
    isFetching,
    refetch,
  };
};

export default useJobs;
